import React from 'react';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

export default class Month extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: 1,
            options: [
                {
                    value: 1,
                    label: 'January',
                },
                {
                    value: 2,
                    label: 'February',
                },
                {
                    value: 3,
                    label: 'March',
                },
                {
                    value: 4,
                    label: 'April',
                },
                {
                    value: 5,
                    label: 'May',
                },
                {
                    value: 6,
                    label: 'June',
                },
                {
                    value: 7,
                    label: 'July',
                },
                {
                    value: 8,
                    label: 'August',
                },
                {
                    value: 9,
                    label: 'September',
                },
                {
                    value: 10,
                    label: 'October',
                },
                {
                    value: 11,
                    label: 'November',
                },
                {
                    value: 12,
                    label: 'December',
                }
            ]
        };
    }

    handleChange = (month) => {
        const newMonth = month.value;
        const newState = Object.assign({},
            this.state,
            {
                selected: newMonth
            }
        );

        const hasChanged =
            this.state.selected !== newState.selected;

        if (hasChanged) {
            this.props.handleChange(newMonth);
            this.setState(newState);
        }
    }

    render() {
        const { selected } = this.state;

        return (
            <div className='row'>
                <div className='col-sm-12 col-md-6 col-xl-4'>
                    <div className='pcb-select'>
                        <label>
                            CHOOSE MONTH
                        </label>

                        <Select
                            name="form-field-name"
                            value={selected}
                            onChange={this.handleChange}
                            options={this.state.options}
                            searchable={false}
                            clearable={false}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/Month.js